export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13743.c0a7484f.jpg";